import { Player } from 'modules/players/domain/interfaces/player';
import { baseApi } from 'shared/api/base-api';

/** Тег перечня игроков: по нему мутации сбрасывают именно список, а не карточки. */
export const PLAYERS_LIST_TAG = { type: 'Player' as const, id: 'PARTIAL-LIST' };

export interface ListPlayersArgs {
  tournamentId: number;
  limit: number;
  offset: number;
  nameFilter?: string;
}

const getPlayersQuery = `#graphql
query getPlayersList($id: Int!, $offset: Int!, $nameFilter: String, $limit: Int!) {
  tournament(id: $id) {
    id
    users(limit: $limit, offset: $offset, nameFilter: $nameFilter) {
      id
      name
      surname
      middleName
      birthDate
      weight
      height
      tournamentAvatars {
        id
        tournament {
          id
        }
        image {
          externalUrl
        }
      }
      photo {
        externalUrl
      }
      positionsInTeams {
        position
        number
        team {
          id
          name
          createdAt
          emblem {
            externalUrl
          }
        }
      }
    }
  }
}
`;

interface GetPlayersResponseDto {
  tournament: {
    id: number;
    users: Player[];
  };
}

export const playersApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    listPlayers: build.query<Player[], ListPlayersArgs>({
      query: ({ tournamentId, limit, offset, nameFilter }) => ({
        query: getPlayersQuery,
        variables: { id: tournamentId, limit, offset, nameFilter },
      }),
      transformResponse: (raw: GetPlayersResponseDto): Player[] => {
        return raw?.tournament?.users ?? [];
      },
      providesTags: (result) =>
        result && result.length
          ? [...result.map((p) => ({ type: 'Player' as const, id: p.id })), PLAYERS_LIST_TAG]
          : [PLAYERS_LIST_TAG],
      keepUnusedDataFor: 60,
    }),
  }),
  overrideExisting: false,
});

export const { useListPlayersQuery, useLazyListPlayersQuery } = playersApi;
